<template>
	<div
		class="absolute top-3 h-7 w-7 rounded-full transition-transform"
		:class="[
			outlineColor,
			{
				'left-3': side === 'left',
				'right-3': side === 'right',
				'-translate-y-1': shine,
				'outline-2 outline-offset-2': outlineColor
			}
		]"
	>
		<Transition
			enterActiveClass="transition-all"
			leaveActiveClass="transition-all"
			leaveToClass="h-0 opacity-0"
			enterFromClass="h-0 opacity-0"
		>
			<ShineIcon class="absolute right-0 bottom-1/2 left-0" v-if="shine" />
		</Transition>
		<LazyImage
			:src="avatar"
			:alt="name"
			class="h-full w-full rounded-full"
			:class="{
				'animate-shake scale-125': shine
			}"
		/>
	</div>
</template>
<script setup lang="ts">
import ShineIcon from '@/assets/icons/shine.svg'
import LazyImage from './LazyImage.vue'
import { computed } from 'vue'

const colors = [
	'outline-[#E01533]', // red
	'outline-[#E4A211]', // yellow
	'outline-[#E06315]', // orange
	'outline-[#84B611]' // green
]

const props = defineProps<{
	avatar: string
	name: string
	team: number
	outlineAvatar?: boolean
	shine?: boolean
	side: 'left' | 'right'
}>()

const outlineColor = computed(() => {
	if (!props.outlineAvatar) {
		return undefined
	}

	return colors[props.team] || ''
})
</script>
